// Parse auriga-settings cookie for necessary AppSync values
import { DIMSUM_SERVICE_ID } from '@amzn/gft-dimsum-service';
import { getAurigaSettings } from '@utils/cookies.ts';

const aurigaSettings = getAurigaSettings();

const dimSumApiConfig = {
  name: 'dimSumApi',
  serviceId: DIMSUM_SERVICE_ID,
  region: 'us-west-2',
  endpoint: aurigaSettings.apiParams.dimSumGraphqlEndpoint,
  authMode: 'iam' as const,
};

export default dimSumApiConfig;
